import { useQuery, UseQueryOptions } from 'react-query';

import { User } from '@/API/models';

type CurrentUserResponse = User;

const currentUserQuery = (): UseQueryOptions<
  CurrentUserResponse,
  Response | Error
> => ({
  queryKey: ['currentUser'],
  queryFn: async () => {
    const response = await fetch('/api/v1/current_user');

    if (response.ok) {
      return await response.json();
    } else {
      throw response;
    }
  },
  retry: (failureCount) => {
    return failureCount < 3;
  },
  staleTime: 5 * 1000 * 60, // 5 min
});

export const useCurrentUser = () => {
  return useQuery(currentUserQuery());
};
